import { useContext } from 'react';
import { ProgressNotifierContext } from './ProgressNotifierContext';

export const useProgressNotifierContext = () => useContext(ProgressNotifierContext);
